import React from 'react';

import { Card } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';

const ChartCardSkeleton: React.FC = () => (
  <Card className="flex flex-col gap-4 p-4 shadow-sm">
    <div className="flex items-center justify-between">
      <Skeleton className="h-4 w-40" />
      <Skeleton className="h-8 w-24 rounded-md" />
    </div>
    <Skeleton className="h-[220px] w-full" />
  </Card>
);

/** Page-shaped placeholder while the organization and programs resolve. */
export const CasesAnalyticsSkeleton: React.FC = () => (
  <div
    className="flex flex-col gap-4"
    role="status"
    aria-busy="true"
    aria-label="Loading AE / PQC analytics"
  >
    <div className="flex flex-wrap items-center gap-3">
      <Skeleton className="h-9 w-44" />
      <Skeleton className="h-9 w-44" />
      <Skeleton className="h-9 w-48" />
      <Skeleton className="h-9 w-56" />
    </div>

    <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
      {Array.from({ length: 3 }).map((_, i) => (
        <Card key={i} className="flex flex-col gap-3 p-4 shadow-sm">
          <div className="flex items-center gap-2">
            <Skeleton className="h-7 w-7 rounded-md" />
            <Skeleton className="h-3 w-24" />
          </div>
          <Skeleton className="h-6 w-28" />
          <Skeleton className="h-3 w-20" />
        </Card>
      ))}
    </div>

    <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
      {Array.from({ length: 2 }).map((_, col) => (
        <ChartCardSkeleton key={col} />
      ))}
    </div>

    <div className="grid grid-cols-1 gap-3 md:grid-cols-3">
      {Array.from({ length: 3 }).map((_, i) => (
        <Card key={i} className="flex flex-col items-center gap-3 p-4 shadow-sm">
          <Skeleton className="h-4 w-32 self-start" />
          <Skeleton className="h-36 w-36 rounded-full" />
        </Card>
      ))}
    </div>

    {/* Time-to-submit card. Step-time is hidden (STEP_TIME_TEMPORARILY_HIDDEN in the container). */}
    <ChartCardSkeleton />
  </div>
);
